"use client";

import Script from "next/script";

const CLARITY_PROJECT_ID = process.env.NEXT_PUBLIC_MICROSOFT_CLARITY_ID;

export default function MicrosoftClarity() {
  // Debug: log Clarity status in browser console
  if (typeof window !== "undefined") {
    console.log("[Clarity Debug] NEXT_PUBLIC_MICROSOFT_CLARITY_ID:", CLARITY_PROJECT_ID || "NOT SET");
  }

  if (!CLARITY_PROJECT_ID) {
    console.warn("[Clarity Debug] Microsoft Clarity disabled - no project ID found. Check NEXT_PUBLIC_MICROSOFT_CLARITY_ID env var.");
    return null;
  }

  return (
    <Script
      id="microsoft-clarity"
      strategy="afterInteractive"
      onLoad={() => console.log("[Clarity Debug] Script loaded successfully for project:", CLARITY_PROJECT_ID)}
      onError={(e) => console.error("[Clarity Debug] Script failed to load:", e)}
    >
      {`
        (function(c,l,a,r,i,t,y){
          c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
          t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
          y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
          console.log("[Clarity Debug] Clarity tag injected for ID:", i);
        })(window, document, "clarity", "script", "${CLARITY_PROJECT_ID}");
      `}
    </Script>
  );
}
